import React, { Fragment, useState } from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import UserSelection from "./UserSelection";
import DateTimePicker from "react-datetime-picker";
import { useAuth } from "../context/AuthContext";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";

export const AvailabilityAddNew = ({
  pageHeaderMsg,
  forceUpdate,
  close = null,
  selectUser = null,
}) => {
  const UserDefaultValue = () => {
    if (selectUser === null) return null;
    return selectUser;
  };
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(UserDefaultValue());
  const [date, setDate] = useState(null);
  const [isEarly, setIsEarly] = useState(false);
  const [isLate, setIsLate] = useState(false);
  const [isLongDay, setIsLongDay] = useState(false);
  const [isTwilight, setIsTwilight] = useState(false);
  const [isNight, setIsNight] = useState(false);
  const [isEvening, setIsEvening] = useState(false);

  const onSubmitAvailability = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const payload = {
        user: user,
        date: date?.toISOString(),
        early: isEarly,
        night: isNight,
        twilight: isTwilight,
        late: isLate,
        longday: isLongDay,
        evening: isEvening,
      };

      const response = await authAxios().post(
        "/api/backoffice/availability/create",
        payload,
        config,
      );
      setLoading(false);
      console.log("payload", payload);
      console.log(response);
      forceUpdate();
      close();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Fragment>
      <Container fluid>
        <Form noValidate onSubmit={onSubmitAvailability}>
          <Row className="mb-4 align-items-center">
            <Form.Group as={Col} controlId={"formUser"}>
              <Form.Control
                as={UserSelection}
                defaultValue={user}
                onSelected={setUser}
                placeholder={"Select User"}
                disabled={selectUser ? true : false}
              />
              <Form.Control.Feedback
                className={"p-0 m-0 mb-2"}
                type={"invalid"}
              >
                Please select a user.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Control
                as={DateTimePicker}
                minDate={new Date()}
                format={"dd/MM/yyyy"}
                onChange={(value) => {
                  setDate(value);
                }}
                value={date}
                required
              />
              <Form.Control.Feedback
                className={"p-0 m-0 mb-2"}
                type={"invalid"}
              >
                Please select a date.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isEarly}
            onChange={() => setIsEarly(!isEarly)}
            label={"Early"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isLate}
            onChange={() => setIsLate(!isLate)}
            label={"Late"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isLongDay}
            onChange={() => setIsLongDay(!isLongDay)}
            label={"Long Day"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isTwilight}
            onChange={() => setIsTwilight(!isTwilight)}
            label={"Twilight"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isNight}
            onChange={() => setIsNight(!isNight)}
            label={"Night"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isEvening}
            onChange={() => setIsEvening(!isEvening)}
            label={"Evening"}
          />
        </Form>
      </Container>
      <ButtonModalFormSaveClose
        saveName={"Create Availability"}
        formSave={onSubmitAvailability}
        close={close}
        loading={loading}
      />
    </Fragment>
  );
};
